// One closing score per UTC day keeps frequent scans from weighting the average.
export function buildReadinessTrend(
  data: Array<{ overall: number; snapshotAt: string }>
) {
  const days = new Map<number, { date: number; overall: number }>()
  for (const snapshot of [...data].sort(
    (a, b) => Date.parse(a.snapshotAt) - Date.parse(b.snapshotAt)
  )) {
    const date = Date.parse(snapshot.snapshotAt)
    days.set(Math.floor(date / 86_400_000), { date, overall: snapshot.overall })
  }
  const weeks = new Map<
    number,
    { date: number; overall: number; sum: number; count: number }
  >()
  for (const [day, point] of days) {
    // UTC weeks start on Monday; the Unix epoch started on Thursday.
    const week = Math.floor((day + 3) / 7)
    const previous = weeks.get(week)
    weeks.set(week, {
      ...point,
      sum: (previous?.sum ?? 0) + point.overall,
      count: (previous?.count ?? 0) + 1,
    })
  }
  const points = [...weeks.values()].map(({ date, overall, sum, count }) => ({
    date,
    overall,
    average: sum / count,
  }))
  const first = [...days.values()][0]
  // Keep the full time range, including short histories within a single week.
  if (first && first.date < points[0].date) {
    points.unshift({ ...first, average: points[0].average })
  }
  return points
}
